import getPageType from './getPageType';
import getUuid from './getUuid';
import logEvent from './logEvent';
import useInit from './useInit';
import useLogPageView from './useLogPageView';
import * as userProfile from './userProfile';
export * from './utils';

export {
  useInit,
  useLogPageView,
  logEvent,
  getPageType,
  getUuid,
  userProfile,
};
